import { Card } from '@/shared/components/ui/card'

/** Esqueleto del tab "Historial" de un negocio. */
export function BusinessHistoryTabSkeleton() {
  return (
    <div className="space-y-2">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="h-16 animate-pulse rounded-card bg-surface" />
      ))}
    </div>
  )
}

/** Esqueleto del tab "Información general": grid de cards con filas key-value. */
export function BusinessOverviewTabSkeleton() {
  return (
    <div className="grid gap-6 lg:grid-cols-3">
      {/* Columna principal */}
      <div className="space-y-6 lg:col-span-2">
        {/* Overview card */}
        <Card className="space-y-3 p-6">
          <div className="h-4 w-40 animate-pulse rounded bg-surface" />
          <div className="space-y-3">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="flex justify-between gap-4">
                <div className="h-4 w-28 animate-pulse rounded bg-surface" />
                <div className="h-4 w-44 animate-pulse rounded bg-surface" />
              </div>
            ))}
          </div>
        </Card>
        {/* Address card */}
        <Card className="space-y-3 p-6">
          <div className="h-4 w-32 animate-pulse rounded bg-surface" />
          <div className="space-y-3">
            {Array.from({ length: 2 }).map((_, i) => (
              <div key={i} className="flex justify-between gap-4">
                <div className="h-4 w-24 animate-pulse rounded bg-surface" />
                <div className="h-4 w-48 animate-pulse rounded bg-surface" />
              </div>
            ))}
          </div>
        </Card>
      </div>
      {/* Meta card */}
      <Card className="space-y-3 p-6">
        <div className="h-4 w-24 animate-pulse rounded bg-surface" />
        <div className="space-y-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="flex justify-between gap-4">
              <div className="h-4 w-20 animate-pulse rounded bg-surface" />
              <div className="h-4 w-24 animate-pulse rounded bg-surface" />
            </div>
          ))}
        </div>
      </Card>
    </div>
  )
}

/**
 * Esqueleto de página completa del detalle de un negocio.
 * Muestra: back-link → header (logo + nombre + badge) → tab bar (3 tabs) → tab "Información general".
 */
export function BusinessDetailPageSkeleton() {
  return (
    <div className="space-y-6">
      {/* Back link */}
      <div className="h-4 w-36 animate-pulse rounded bg-surface" />

      {/* Header */}
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex items-center gap-4">
          {/* Logo circle */}
          <div className="h-14 w-14 animate-pulse rounded-full bg-surface" />
          <div className="space-y-2">
            <div className="h-8 w-48 animate-pulse rounded bg-surface" />
            <div className="h-3 w-32 animate-pulse rounded bg-surface" />
          </div>
        </div>
        <div className="flex flex-col items-end gap-2">
          <div className="h-6 w-24 animate-pulse rounded-full bg-surface" />
          <div className="h-4 w-36 animate-pulse rounded bg-surface" />
        </div>
      </div>

      {/* Tab bar */}
      <div className="flex gap-2 border-b border-line pb-0">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="h-9 w-32 animate-pulse rounded-t bg-surface" />
        ))}
      </div>

      {/* Tab content — overview */}
      <BusinessOverviewTabSkeleton />
    </div>
  )
}
